var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


$(document).ready(function () {
  $('.main-div').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true,
    infinite: true,
    prevArrow: '<svg class="slick-prev slick-arrow" width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-1.66948e-07 14C-1.60964e-07 13.4981 0.192075 12.9964 0.575418 12.6138L12.6445 0.574397C13.4122 -0.191466 14.657 -0.191466 15.4244 0.574397C16.1919 1.33995 16.1919 2.58142 15.4244 3.34734L4.74504 14L15.4241 24.6526C16.1915 25.4185 16.1915 26.6598 15.4241 27.4253C14.6566 28.1916 13.4119 28.1916 12.6441 27.4253L0.575044 15.3861C0.19164 15.0033 -1.7293e-07 14.5016 -1.66948e-07 14Z" fill="#161616"/></svg>',
    nextArrow: '<svg class="slick-next slick-arrow" width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 14C16 13.4981 15.8079 12.9964 15.4246 12.6138L3.35551 0.574397C2.58777 -0.191466 1.34301 -0.191466 0.575574 0.574397C-0.191858 1.33995 -0.191858 2.58142 0.575574 3.34734L11.255 14L0.575947 24.6526C-0.191485 25.4185 -0.191485 26.6598 0.575947 27.4253C1.34338 28.1916 2.58814 28.1916 3.35588 27.4253L15.425 15.3861C15.8084 15.0033 16 14.5016 16 14Z" fill="#161616"/></svg>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });
});

// abz-featured-slider
  $('.abz-featured-slider').owlCarousel({
    loop: true,
    nav: true,
    rewind: true,
    dots: false,
    margin: 20,
    slideTransition: 'linear',
    autoplay: true,
    autoplayTimeout: 3000,
    smartSpeed: 800,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
        dots: true
      },
      480: {
        items: 2,
        nav: false,
        dots: true
      },
      1025: {
        items: 3
      },
      1200: {
        items: 4,
      }
    }
  });

